import { useEffect } from 'react';
import { useToast } from '../Toast/context/useToast.context';

export function ErrorToastFallbackComponent({ title, body }: { title: string; body: string }) {
  const { toggleToast } = useToast();

  useEffect(() => {
    toggleToast({
      title: title,
      body: body,
      severity: 'error'
    });
  }, [title, body, toggleToast]);

  return null;
}
